import { useCallback, useMemo } from 'react'
import { CustomSelectBase } from '../../../forms/CustomSelect'
import { CustomSelectSectionSearchbarDropDown, CustomSelectSectionsProps } from '../../../forms/CustomSelect/CustomSelectSections'
import { Modify } from '../../../utils/globals/types'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { DictionarySupplier, SupplierPayload } from '../../../utils/reducers/products/suppliers'
import { DisplayTextFuncTy } from '../../../forms/CustomSelect/types'
import { parseSuppliersToSections } from './function'

type CustomSelectAndCreateSuppliersProps = Modify<CustomSelectSectionsProps, {
    suppliers: SupplierPayload
    items?: never
}>

const CustomSelectAndCreateSuppliers: React.FC<CustomSelectAndCreateSuppliersProps> = ({ suppliers, ...rest }) => {
    const { suppliersSectionItems , displayTextFunc } = useCustomSelectAndCreateSupplierLogic({ suppliers: suppliers?.suppliers|| {} })
    return (
        <CustomSelectBase {...rest} items={suppliersSectionItems.suppliersSectionItems} DropDownComponent={CustomSelectSectionSearchbarDropDown} displayTextFunc={displayTextFunc} />
    )
}

interface CustomSelectAndCreateSupplierLogicProps {
    suppliers: DictionarySupplier
}

const useCustomSelectAndCreateSupplierLogic = ({ suppliers }: CustomSelectAndCreateSupplierLogicProps) => {
    const { t } = useTwinTranslation()
    const createTrans = t('create', 'Crear')
    const createNewTrans = t('createNew', 'Crear nuevo')
    const suppliersTrans = t('suppliers', 'Proveedores')

    const suppliersSectionItems = useMemo(() => {
        return parseSuppliersToSections(suppliers, { createTrans, createNewTrans, suppliersTrans})
    }, [suppliers, createTrans, createNewTrans, suppliersTrans])

    const displayTextFunc: DisplayTextFuncTy = useCallback((_items, value) => {
        return suppliersSectionItems.indexSuppliers[value]?.text || suppliersSectionItems.indexSuppliers[value as any]
    }, [suppliersSectionItems.indexSuppliers])
    

    return { displayTextFunc, suppliersSectionItems }
}


export default CustomSelectAndCreateSuppliers